export const LEAD_SOURCES = [
  "Google Ads", "Meta Ads", "WhatsApp", "Website", "Referral",
  "Walk-in", "Phone Call", "Organic", "Other",
];

export const LEAD_STATUSES = [
  { value: "new", label: "New", badge: "bg-sky-50 text-sky-700 hover:bg-sky-50" },
  { value: "contacted", label: "Contacted", badge: "bg-indigo-50 text-indigo-700 hover:bg-indigo-50" },
  { value: "qualified", label: "Qualified", badge: "bg-teal-50 text-teal-700 hover:bg-teal-50" },
  { value: "appointment_scheduled", label: "Appointment Scheduled", badge: "bg-violet-50 text-violet-700 hover:bg-violet-50" },
  { value: "converted", label: "Converted", badge: "bg-emerald-50 text-emerald-700 hover:bg-emerald-50" },
  { value: "lost", label: "Lost", badge: "bg-red-50 text-red-600 hover:bg-red-50" },
];

export const LEAD_PRIORITIES = [
  { value: "hot", label: "Hot", badge: "bg-red-50 text-red-600 hover:bg-red-50" },
  { value: "warm", label: "Warm", badge: "bg-amber-50 text-amber-600 hover:bg-amber-50" },
  { value: "cold", label: "Cold", badge: "bg-slate-100 text-slate-500 hover:bg-slate-100" },
];

export const LOST_REASONS = [
  "Not Interested", "Price Concern", "No Response", "Chose Another Provider",
  "Location Issue", "Treatment Postponed", "Duplicate / Invalid Lead", "Other",
];

export const GENDERS = ["Male", "Female", "Other"];

export const statusMeta = (v) =>
  LEAD_STATUSES.find((s) => s.value === v) || { value: v, label: v, badge: "bg-slate-100 text-slate-600" };

export const priorityMeta = (v) =>
  LEAD_PRIORITIES.find((p) => p.value === v) || { value: v, label: v, badge: "bg-slate-100 text-slate-600" };

export function initials(name = "") {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}
